import React, { useEffect, useState, useContext, Fragment } from "react";
// import SharedDataContext from "../../../../_helper/SharedData";
import SharedDataContext from "../../../../../_helper/SharedData";
import { showAlert } from "../../../../../Services/Shared.service";
import { Breadcrumbs } from "../../../../../AbstractElements";
import { Row, Col, Card, CardBody, Container } from "reactstrap";
import {
  getPackagesListCorp,
  getPackage,
} from "../../../../../Services/Packages.service";
import PackageInput from "../../../../Packages/PackageInput";
import CustomizerContext from "../../../../../_helper/Customizer";
import PackagesTable from "./PackagesTable";
import { getPackagesListExt } from "../../../../../Services/ExternalThirdParty.service";
 


function ExtPackagesTableView({ corpId }) {
  const { cityData, globalCityField, setShowApiLoader,packageTable } =
    useContext(SharedDataContext);
  const [tableData, setTableData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [pagination, setPagination] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [paginationTotalRows, setPaginationTotalRows] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [editId, setEditId] = useState("");
  const [searchData, setSearchData] = useState("");
  const [filterType, setFilterType] = useState("");
  const [filterData, setFilterData] = useState([]);
  const { mix_background_layout } = useContext(CustomizerContext);


  const onChangePage = (page) => {
    console.log("page", page);
    setPagination(page - 1);
  };

  const onChangeRowsPerPage = (currentRowsPerPage) => {
    setRowsPerPage(currentRowsPerPage);
  };

  const disableLoaders = () => {
    setLoader(false);
    // setShowApiLoader(false);
  };

  useEffect(() => {
    fetchTableData();
  }, [corpId, pagination, rowsPerPage]);
  useEffect(() => {
    fetchTableData()
  }, [packageTable])
  

  const fetchTableData = () => {
    let obj = {
      corporateId: corpId,
    };
    setLoader(true);
    getPackagesListExt(obj)
      .then((result) => {
        console.log("List of pack",result.data)
        // setPaginationTotalRows(result.data);
        setTableData(result.data.list);
        setPaginationTotalRows(tableData.length)
        disableLoaders();
      })
      .catch((err) => {
        disableLoaders();
        showAlert(
          "error",
          err.response?.data?.message
            ? err.response.data.message
            : "Something went wrong"
        );
      });
  };



  const onEditClick = (obj) => {
    setIsOpen(!isOpen);
    setEditId(obj.id);
  };

  const toggleModal = () => {
    fetchTableData();
    setEditId("");
    setIsOpen(!isOpen);
  };

  return (
    <Fragment>
      <Row>
        <Col sm="12">
          <Card>
            <CardBody className="p-0">
              <PackagesTable
                fetchTableData={fetchTableData}
                tableData={tableData}
                setShowApiLoader={setLoader}
                onChangePage={onChangePage}
                paginationPerPage={rowsPerPage}
                paginationTotalRows={paginationTotalRows}
                onChangeRowsPerPage={onChangeRowsPerPage}
                onEditClick={onEditClick}
                loader={loader}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
      <PackageInput cityData={cityData} editId={editId} isOpen={isOpen} toggleModal={toggleModal} isExt={true} />
      </Fragment>
  );
}

export default ExtPackagesTableView;
